import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ADD_ANSWERS = 'add answers'
export const RETURN = 'return'
export const VALIDATION_APPLY_COUNTRY = 'validation apply country'

export default {
  [PORTUGUESE]: {
    [ADD_ANSWERS]: 'Clique para adicionar respostas',
    [RETURN]: 'Retornar',
    [VALIDATION_APPLY_COUNTRY]:
      'Este criador de perfil não pode ser aplicado a este país',
  },

  [ENGLISH]: {
    [ADD_ANSWERS]: 'Click to add answers',
    [RETURN]: 'Return',
    [VALIDATION_APPLY_COUNTRY]: 'This profiler cannot be applied to this country',
  },

  [SPANISH]: {
    [ADD_ANSWERS]: 'Haga clic para agregar respuestas',
    [RETURN]: 'Regreso',
    [VALIDATION_APPLY_COUNTRY]:
      'Este generador de perfiles no se puede aplicar a este país',
  },
}
